<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Chez l'adulte",
          id: "adulte",
          text: `#### Définition
L’OMS (Organisation Mondiale de la Santé) définit la basse vision lorsque la vision binoculaire (les deux yeux ensemble) avec la meilleure correction de lunettes possible est inférieure ou égale à 3/10 ou bien que le champ visuel binoculaire est inférieur à 20°.

#### Symptômes
Les maladies oculaires telles que la DMLA, le glaucome, les rétinites pigmentaires (et bien d’autres) atteignent l’acuité visuelle et/ou le champ de vision central ou périphérique. Les déplacements, ou bien la lecture deviennent difficiles voir impossibles. Les patients se retrouvent assez vite en situation de dépendance importante.

![Atteinte d’une DMLA](/prisesEnChargeImages/image14.jpg)
*Atteinte d’une DMLA*
![Champ visuel tubulaire (Glaucome stade terminal)](/prisesEnChargeImages/image13.jpg)
*Champ visuel tubulaire (Glaucome stade terminal)*
#### Traitement

Chez l’adulte, la rééducation orthoptique spécifique pour la basse vision couplée à un ou plusieurs systèmes optiques adéquats permettent aux patients de se sentir plus à l’aise dans leur quotidien en grossissant les objets et utilisant le champ de vision restant. En reprogrammant les réflexes visuels habituels et en changeant les repères, les patients arrivent à retrouver une certaine part d’autonomie et reprennent goût à certaines occupations (lecture en gros caractères, tâches quotidiennes, déplacements).

L’orthoptiste travaille en lien avec différents professionnels comme les ophtalmologistes, les opticiens, les ergothérapeutes, les instructeurs en locomotion, les psychologues. [http://grenoble.avh.asso.fr/](http://grenoble.avh.asso.fr/)`
        },
        {
          title: "Chez l'enfant",
          id: "enfant",
          text: `
#### Définition
L’OMS (Organisation Mondiale de la Santé) définit la basse vision lorsque la vision binoculaire (les deux yeux ensemble) avec la meilleure correction de lunettes possible est [https://www.who.int/fr/news-room/fact-sheets/detail/blindness-and-visual-impairment](inférieure ou égale à 3/10) ou bien que le champ visuel binoculaire est inférieur à 20°.

#### Symptômes
La basse vision atteint également les enfants. Les pathologies sont différentes de celles des adultes: Les pathologies congénitales (rétinites pigmentaires, maladie de Stargart, glaucome congénital, albinisme, syndrome d’Usher, amaurose de Leber, cataracte congénitale)
Les malformations des voies optiques ou oculaires (microcornée, microphtalmie, buphtalmie, aniridie, colobome chrorio-rétinien)
Les affection périnatales (souffrance néonatale, toxoplasmose gestationnelle, prématurité).

#### Traitement

La prise en charge orthoptique d’un enfant déficient visuel consiste à le stimuler malgré tout et à lui apprendre à faire autrement. La vision est le socle du bon développement global de l’enfant. Une équipe pluridisciplinaire d’orthoptiste, psychomotricien, orthophoniste, éducateur spécialisé, pédiatre, ophtalmologiste, enseignant spécialisé, psychologue et instructeur en locomotion sauront éveiller et développer le potentiel de l’enfant, souvent au sein d’une structure spécialisée ([CAMPS](https://camspapf38.com/))`
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>
